import React from 'react';
import { motion } from 'framer-motion';
import { Presentation, Users, Eye, DollarSign, Wine, Gift } from 'lucide-react';
import { TreatedImage } from './TreatedImage';
import { ReserveButton } from './ReserveButton';
const items = [{
  icon: Presentation,
  title: 'A presentation from Dr Fiona',
  description: 'on the science behind the Collagen Reset.'
}, {
  icon: Users,
  title: 'Meet the team',
  description: 'members of our nursing team and subject-matter experts from our partner vendors, on hand for your questions.'
}, {
  icon: Eye,
  title: 'A first look at the treatment',
  description: 'and what it can do for your skin.'
}, {
  icon: DollarSign,
  title: 'Special launch pricing',
  description: 'available only on the evening.'
}, {
  icon: Wine,
  title: 'Wine, cocktails, and light bites',
  description: 'as our guest.'
}, {
  icon: Gift,
  title: 'A prize drawing',
  description: 'for a $2,200 treatment.'
}];
export function EveningSection() {
  return <section id="evening" className="relative py-24 md:py-32 bg-bc-surface" data-id="element-46">
      <div className="container mx-auto px-6" data-id="element-47">
        <div className="max-w-5xl mx-auto" data-id="element-48">
          {/* Header */}
          <div className="text-center space-y-6 mb-16" data-id="element-49">
            <div className="text-bc-pink font-sans text-xs md:text-sm tracking-wide2 uppercase" data-id="element-50">
              THE EVENING
            </div>
            <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-bc-bone" data-id="element-51">
              WHAT TO EXPECT
            </h2>
          </div>

          {/* Image + items */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-12" data-id="element-52">
            {/* Treated team image */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1]
          }} className="grid grid-cols-2 gap-4" data-id="element-53">
              <TreatedImage src="https://cdn.magicpatterns.com/uploads/ie7dACGhGJ7SFME26dnyuG/be-clinical-under-eye-filler-17.jpg" alt="A Be CLINICAL provider with a patient during treatment" wrapperClassName="aspect-[3/4] w-full" data-id="element-54" />
              <TreatedImage src="https://cdn.magicpatterns.com/uploads/nGYJkZFsda2GGjhS7Dh3Mn/Wine_and_Bites.png" alt="Wine, cheese, and charcuterie served at the event" wrapperClassName="aspect-[3/4] w-full" data-id="element-55" />
            </motion.div>

            {/* Items list */}
            <div className="grid grid-cols-1 gap-6 md:gap-7" data-id="element-56">
              {items.map((item, index) => {
              const Icon = item.icon;
              return <div key={index} className="flex gap-4" data-id="element-57">
                    <div className="flex-shrink-0 mt-1" data-id="element-58">
                      <Icon className="w-6 h-6 text-bc-pink" strokeWidth={1.5} data-id="element-59" />
                    </div>
                    <div className="space-y-1" data-id="element-60">
                      <h3 className="font-sans font-semibold text-lg md:text-xl text-bc-bone" data-id="element-61">
                        {item.title}
                      </h3>
                      <p className="text-bc-bone-2 font-sans text-base md:text-lg leading-relaxed" data-id="element-62">
                        {item.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </div>

          {/* Emphasized line */}
          <p className="text-center text-bc-pink font-sans text-sm md:text-base tracking-wide2 uppercase" data-id="element-63">
            SPACES ARE LIMITED, RESERVED FOR OUR PATIENTS FIRST.
          </p>

          <div className="mt-10 flex justify-center" data-id="element-64">
            <ReserveButton label="CLAIM YOUR SPOT" className="w-full sm:w-auto" data-id="element-65" />
          </div>
        </div>
      </div>
    </section>;
}